import { render, staticRenderFns } from "./ManageRicUsers.vue?vue&type=template&id=507c5efb"
import script from "./ManageRicUsers.vue?vue&type=script&lang=ts"
export * from "./ManageRicUsers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports